import React from 'react';
import type { HeaderProps } from '../types';
import { CloseIcon } from './icons/CloseIcon';
import { WebyesLogoIcon } from './icons/WebyesLogoIcon';
import { DesktopIcon } from './icons/DesktopIcon';
import { MobileIcon } from './icons/MobileIcon';
import { ChevronDownIcon } from './icons/ChevronDownIcon';
import { HelpIcon } from './icons/HelpIcon';

export const Header: React.FC<HeaderProps> = ({
  onClose,
  selectedDevice,
  onDeviceChange
}) => {
  return (
    <div className="cy:flex cy:justify-between cy:items-center cy:px-4 cy:py-4 cy:bg-blue-800 cy:text-white cy:min-h-[60px] cy:flex-shrink-0 cy:gap-1">
      {/* Left: WebYes Logo */}
      <div className="cy:flex-1">
        <WebyesLogoIcon />
      </div>

      {/* Right: Help, Device Selector and Close Button */}
      <div className="cy:flex cy:items-center cy:gap-2 cy:flex-1 cy:justify-end">
        {/* Help/Support Link */}
        <a
          href="https://wordpress.org/support/plugin/accessibility-plus/#new-topic-0"
          target="_blank"
          rel="noopener noreferrer"
          className="cy:border-0 cy:rounded-full cy:w-8 cy:h-8 cy:text-white cy:cursor-pointer cy:flex cy:items-center cy:justify-center cy:transition-colors cy:hover:bg-opacity-20 cy:bg-transparent"
          aria-label="Get help and support"
        >
          <HelpIcon size={20} />
        </a>
        
        {/* ViewportSwitcher */}
        <div className="cy:relative cy:flex cy:items-center cy:gap-2 cy:bg-white cy:px-3 cy:py-2 cy:rounded-md">
          <div className="cy:flex cy:items-center cy:gap-1 cy:text-gray-700 cy:pointer-events-none">
            {selectedDevice === 'desktop' ? <DesktopIcon /> : <MobileIcon />}
          </div>
          <select
            name="device-type" 
            id="device-type"
            className="cy:bg-transparent cy:border-0 cy:text-gray-900 cy:text-sm cy:font-medium cy:cursor-pointer cy:outline-none cy:appearance-none cy:pr-5"
            value={selectedDevice}
            onChange={(e) => onDeviceChange(e.target.value as 'desktop' | 'mobile')}
            aria-label="Select device type"
          >
            <option value="desktop" className="cy:bg-white cy:text-gray-900">
              Desktop
            </option>
            <option value="mobile" className="cy:bg-white cy:text-gray-900">
              Mobile
            </option>
          </select>
          <div className="cy:absolute cy:right-2 cy:text-gray-700 cy:pointer-events-none">
            <ChevronDownIcon />
          </div>
        </div>
        
        <button
          className="cy:border-0 cy:rounded-full cy:w-8 cy:h-8 cy:text-white cy:text-base cy:cursor-pointer cy:flex cy:items-center cy:justify-center cy:transition-colors cy:hover:bg-opacity-20 cy:bg-transparent"
          onClick={onClose}
          aria-label="Close dashboard"
        >
          <CloseIcon />
        </button>
      </div>
    </div>
  );
};

